import { observeHomepageGame } from "./homepageExperiment";
import { api } from "./api";

export type ProductEventType =
  | "guest_progress_offered"
  | "guest_progress_dismissed"
  | "guest_progress_save_selected"
  | "guest_session_started"
  | "homepage_viewed"
  | "homepage_play_selected"
  | "homepage_signup_selected"
  | "homepage_puzzle_completed"
  | "homepage_app_selected"
  | "guest_name_changed"
  | "guest_name_keep_selected"
  | "signup_completed"
  | "game_started"
  | "game_finished"
  | "placement_game_finished"
  | "first_game_started"
  | "first_game_finished"
  | "joined_league"
  | "opened_game_review"
  | "subscribed" // Legacy client confirmation; never payment evidence.
  | "paywall_viewed"
  | "paywall_dismissed"
  | "paywall_continue_selected"
  | "review_practice_checked"
  | "mistake_practice_offered"
  | "practice_next_action"
  | "daily_practice_offered"
  | "daily_practice_selected"
  | "page_view";

const guestSessionKey = "chesshotel:analytics:guest-session:v1";

function guestSessionId(): string | null {
  try {
    return typeof window === "undefined"
      ? null
      : window.sessionStorage.getItem(guestSessionKey);
  } catch {
    return null;
  }
}

// Tab-scoped identity: no names, IP addresses, or cross-device identity inference.
export function trackGuestSessionStarted() {
  try {
    if (!guestSessionId())
      window.sessionStorage.setItem(
        guestSessionKey,
        window.crypto.randomUUID()
      );
    void trackEvent("guest_session_started");
  } catch {
    // Storage may be blocked. Gameplay must continue without analytics.
  }
}

export async function trackEvent(type: ProductEventType, metadata?: any) {
  if (type === "game_started" || type === "game_finished") void observeHomepageGame(type, metadata?.gameId);
  try {
    const guestId = guestSessionId();
    const context = {
      ...metadata,
      ...(guestId ? { guestSessionId: guestId } : {}),
    };
    // We send to our internal API
    await api.post("/admin/track", {
      type,
      metadata: Object.keys(context).length ? JSON.stringify(context) : null,
      timestamp: new Date().toISOString(),
    });
    if (type === "signup_completed" && guestId) {
      try {
        window.sessionStorage.removeItem(guestSessionKey);
      } catch {
        /* optional storage */
      }
    }

    // Note: We could also call ym() or gaEvent() here if we want a single entry point
  } catch (e) {
    console.error("Failed to track event", e);
  }
}

const paywallKey = "chesshotel:paywall-source:v1";
const sources = ["league_limit", "review_limit", "analysis_limit"];
export function rememberPaywallSource(source: string, userId: number) {
  try {
    if (sources.includes(source))
      window.sessionStorage.setItem(
        paywallKey,
        JSON.stringify({ source, userId, at: Date.now() })
      );
  } catch {
    /* optional attribution */
  }
}
export function checkoutPaywallSource(userId: number): string | undefined {
  try {
    const value = JSON.parse(window.sessionStorage.getItem(paywallKey) || "null");
    if (
      value &&
      sources.includes(value.source) &&
      value.userId === userId &&
      Date.now() - value.at >= 0 &&
      Date.now() - value.at < 30 * 60 * 1000
    )
      return value.source;
  } catch {
    /* optional attribution */
  }
  return undefined;
}
